import { queryOptions } from "@tanstack/react-query";
import { apiGet } from "@softmax/observatory-client/client";
import type {
  CredentialResponseBase,
  PlayerCredentialResponseBase,
} from "@softmax/observatory-client/types";

export type CredentialTarget =
  | { kind: "user" }
  | { kind: "player"; playerId: string; playerName: string };
export type CredentialRecord =
  | CredentialResponseBase
  | PlayerCredentialResponseBase;
export function credentialPath({ target }: { target: CredentialTarget }) {
  return target.kind === "user"
    ? "/credentials"
    : `/players/${encodeURIComponent(target.playerId)}/credentials`;
}
export function credentialsKey({
  viewerId,
  target,
}: {
  viewerId: string;
  target: CredentialTarget;
}) {
  return [
    "credentials",
    viewerId,
    target.kind === "user" ? "user" : target.playerId,
  ] as const;
}
export function credentialsQueryOptions({
  viewerId,
  target,
}: {
  viewerId: string;
  target: CredentialTarget;
}) {
  return queryOptions({
    queryKey: credentialsKey({ viewerId, target }),
    queryFn: ({ signal }) =>
      apiGet<CredentialRecord[]>(credentialPath({ target }), {
        signal,
        elevatedPrivileges: false,
      }),
    staleTime: 30_000,
  });
}
